import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@shared/services/auth/auth.service';
import { USER_INFO_LOCAL_STORAGE_KEY } from '@shared/utils/constant';
import { catchError, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn,
) => {
  const isExcluded =
    req.url.includes('assets/i18n') ||
    req.url.includes('auth') ||
    req.url.includes('forget-password') ||
    req.url.includes('reset-password') ||
    req.url.includes('api/v1/auth/user-info');

  const _authService = inject(AuthService);
  const _router = inject(Router);

  if (!isExcluded) {
    // const token = localStorage.getItem('access_token');
    // const organizationId = localStorage.getItem('cuOrg');
    const crUsrStr = localStorage.getItem(USER_INFO_LOCAL_STORAGE_KEY);
    if (crUsrStr) {
      let roleId = '';
      let token = '';
      let organizationId = '';
      let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      let isStudent = false;
      try {
        const currentUserInfo = JSON.parse(crUsrStr);
        const tUser = currentUserInfo?.tUser;
        roleId =
          typeof tUser?.tRole === 'string'
            ? tUser.tRole
            : tUser?.tRole?._id;
        token = currentUserInfo?.sIdToken;
        organizationId =
          typeof tUser?.tUserDetails?.tOrganization === 'string'
            ? tUser.tUserDetails.tOrganization
            : tUser?.tUserDetails?.tOrganization?._id;
        isStudent = !roleId && !tUser?.tUserDetails;
        if (isStudent && !organizationId) {
          const orgs = tUser?.tOrganizations;
          if (Array.isArray(orgs) && orgs.length > 0) {
            const first = orgs[0] as any;
            organizationId =
              typeof first === 'string' ? first : (first?._id ?? '');
          }
        }
      } catch (error) {
        return throwError(
          () =>
            new HttpErrorResponse({
              status: 403,
              statusText: 'Forbidden',
              error: { message: 'Invalid user data. Please login again.' },
            }),
        );
      }

      if (!roleId && !isStudent) {
        return throwError(
          () =>
            new HttpErrorResponse({
              status: 403,
              statusText: 'Forbidden',
              error: { message: 'Role not found. Please login again.' },
            }),
        );
      }

      if (!organizationId) {
        return throwError(
          () =>
            new HttpErrorResponse({
              status: 403,
              statusText: 'Forbidden',
              error: { message: 'Organization not found. Please login again.' },
            }),
        );
      }

      const clonedReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          'x-Organization-Id': organizationId,
          'x-timezone': timeZone,
          // 'Role-Id': roleId,
        },
      });

      return next(clonedReq).pipe(
        catchError((e) => {
          if (e.status === 401) {
            _authService.setLocalRedirectUrl(_router.url);
            _authService.sendToAuth();
          }

          if (e?.error?.error?.statusCode === 404) {
            return throwError(() => e); // return original error untouched
          }

          const errorMessage = e?.error?.error?.message || 'An error occurred';
          return throwError(() => new Error(errorMessage));
        }),
      );
    } else {
      _authService.setLocalRedirectUrl(_router.url);
      _authService.sendToAuth();
    }
  }

  return next(req);
};
